import * as React from 'react';
import {SVGProps} from 'react';

export const RaterStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}>
    <path
      fill={props.fill ?? '#EDC843'}
      d="M3.81 2.97 5.676.552c.144-.189.315-.328.511-.418a1.46 1.46 0 0 1 1.23 0c.197.09.367.23.51.417L9.795 2.97l2.83.95c.31.097.553.274.729.53.176.256.264.536.264.841 0 .144-.02.287-.062.43-.042.143-.11.28-.204.41l-1.825 2.595.066 2.73c.011.415-.128.765-.417 1.049-.29.284-.629.426-1.019.426-.02 0-.143-.016-.37-.046l-2.984-.83-2.983.83a.68.68 0 0 1-.188.041c-.066.006-.129.009-.187.009a1.4 1.4 0 0 1-1.015-.428 1.352 1.352 0 0 1-.413-1.051l.067-2.742L.266 6.129a1.332 1.332 0 0 1-.204-.409 1.46 1.46 0 0 1 .195-1.259c.172-.256.413-.437.724-.542l2.829-.95Z"
    />
  </svg>
);
